import React from "react";
import Rating from "@material-ui/lab/Rating";
// import { withRouter } from "react-router-dom";
function Products(props) {
  const value = parseInt(props.stars);
  return (
    <>
      <div className="product-container">
        <div className={props.product}></div>
        <small className="product-description">
          <b>{props.name}</b>
        </small>
        <span className="product-description">{props.description}</span>
        <Rating value={value} readOnly style={{ marginTop: "90px" }} />
        <span style={{ fontSize: "13px", marginTop: "5px" }}>
          <b>VIEW</b>
        </span>
      </div>
    </>
  );
}
export default Products;
